{
  "fr": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Changer de phase",
        "reset_columns": "Réinitialiser les colonnes"
      },
      "labels": {
        "columns": "Colonnes",
        "milestone": "Veuillez sélectionner une nouvelle phase",
        "no_results": "Aucune unité trouvée"
      }
    }
  }
}
